import { FC } from 'react';

interface MarkerIconProps {
	color: string;
}

const MarkerOneIcon: FC<MarkerIconProps> = ({ color }) => (
	<svg width="28" height="132" viewBox="0 0 28 132" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false">
		<rect x="11.9048" width="2.85714" height="19.0476" rx="1.42857" fill={color} />
		<rect x="12.0298" y="0.125" width="2.60714" height="18.7976" rx="1.30357" stroke="#6B7485" strokeOpacity="0.24" strokeWidth="0.25" />
		<g filter="url(#doodle-marker-one-inner-shadow)">
			<path
				d="M26.6667 129.594V32.8101C26.6667 32.2706 26.2293 31.8333 25.6899 31.8333C25.1504 31.8333 24.7131 31.396 24.7131 30.8565V29.4573C24.7131 29.4078 24.6968 29.3595 24.6669 29.3201L24.2392 28.7563C23.3333 27.5621 22.1336 26.6228 20.757 26.0297L19.0379 18.7067C18.8433 17.8777 18.1038 17.2916 17.2522 17.2916H16.1905V8.5714C16.1905 8.04541 15.7641 7.61902 15.2381 7.61902H11.4286C10.9026 7.61902 10.4762 8.04542 10.4762 8.5714V17.2916H9.41442C8.5629 17.2916 7.82335 17.8777 7.62875 18.7067L5.90965 26.0297C4.53303 26.6228 3.33339 27.5621 2.42745 28.7563L1.99977 29.3201C1.96982 29.3595 1.9536 29.4078 1.9536 29.4573V30.8565C1.9536 31.396 1.51627 31.8333 0.976801 31.8333C0.437329 31.8333 0 32.2706 0 32.8101V129.594C0 130.607 0.821205 131.429 1.83421 131.429H24.8325C25.8455 131.429 26.6667 130.607 26.6667 129.594Z"
				fill="#F8F8F8"
				fillOpacity="0.99"
			/>
		</g>
		<path
			d="M11.4287 7.74402H15.2383C15.6951 7.74412 16.0653 8.11439 16.0654 8.57117V17.4169H17.252C18.0454 17.4169 18.7347 17.9628 18.916 18.7352L20.6357 26.0585L20.6494 26.12L20.708 26.1444C22.0647 26.7289 23.2468 27.655 24.1396 28.8319L24.5674 29.3954C24.5808 29.413 24.5878 29.4348 24.5879 29.4569V30.8563C24.5879 31.4647 25.0811 31.9577 25.6895 31.9579C26.1599 31.9579 26.542 32.34 26.542 32.8104V129.595C26.5418 130.538 25.7759 131.304 24.832 131.304H1.83398C0.890208 131.303 0.125148 130.538 0.125 129.595V32.8104C0.125 32.3401 0.506235 31.958 0.976562 31.9579C1.58507 31.9579 2.07812 31.4648 2.07812 30.8563V29.4569C2.07821 29.4348 2.08622 29.413 2.09961 29.3954L2.52734 28.8319C3.42022 27.655 4.60225 26.7289 5.95898 26.1444L6.0166 26.12L6.03125 26.0585L7.75 18.7352C7.93132 17.9629 8.62072 17.417 9.41406 17.4169H10.6016V8.57117C10.6017 8.11432 10.9718 7.74402 11.4287 7.74402Z"
			stroke="#C0C0C0"
			strokeWidth="0.25"
		/>
		<g filter="url(#doodle-marker-one-highlight)">
			<rect x="19.0476" y="35.381" width="5.71429" height="87.619" fill="white" fillOpacity="0.8" />
		</g>
		<path d="M26.6667 54.0952L26.6667 56L0 56L-8.4317e-08 54.0952L26.6667 54.0952Z" fill={color} />
		<g filter="url(#doodle-marker-one-neck-shadow)">
			<path d="M3 32.381L3 28.381L24 28.381L24 32.381L3 32.381Z" fill="url(#doodle-marker-one-gradient)" fillOpacity="0.7" />
		</g>
		<defs>
			<filter
				id="doodle-marker-one-inner-shadow"
				x="0"
				y="6.70191"
				width="26.6666"
				height="124.727"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
				<feOffset dy="-0.917108" />
				<feGaussianBlur stdDeviation="1.83422" />
				<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
				<feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
			</filter>
			<filter
				id="doodle-marker-one-highlight"
				x="16.2286"
				y="32.5619"
				width="11.3523"
				height="93.2571"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feGaussianBlur stdDeviation="1.40952" result="effect1_foregroundBlur" />
			</filter>
			<filter
				id="doodle-marker-one-neck-shadow"
				x="2.08289"
				y="27.4639"
				width="22.8342"
				height="5.83422"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feGaussianBlur stdDeviation="0.458554" result="effect1_foregroundBlur" />
			</filter>
			<linearGradient id="doodle-marker-one-gradient" x1="13.5" y1="28.381" x2="13.5" y2="32.381" gradientUnits="userSpaceOnUse">
				<stop stopColor="#E0E0E0" stopOpacity="0" />
				<stop offset="1" stopColor="#EBEBEB" />
			</linearGradient>
		</defs>
	</svg>
);

const MarkerTwoIcon: FC<MarkerIconProps> = ({ color }) => (
	<svg width="39" height="133" viewBox="0 0 39 133" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false">
		<path
			d="M19.0489 17.7654C22.5673 17.7654 25.25 17.4078 24.6871 15.1957L21.2641 1.72289C20.6805 -0.574263 17.4171 -0.574297 16.8335 1.72285L13.4019 15.2287C12.8654 17.4298 15.5481 17.7654 19.0489 17.7654Z"
			fill={color}
		/>
		<path
			d="M13.6693 16.4832C13.463 16.1783 13.395 15.7832 13.5228 15.2586L16.9545 1.75372C17.5062 -0.417797 20.5912 -0.417808 21.1429 1.75372L24.5658 15.2264C24.7002 15.7543 24.6373 16.1535 24.434 16.4617C24.2278 16.7742 23.8639 17.0138 23.3568 17.1922C22.3396 17.55 20.81 17.6404 19.0492 17.6404C17.2968 17.6404 15.771 17.5552 14.7523 17.2039C14.2444 17.0288 13.8787 16.7927 13.6693 16.4832Z"
			stroke="#6B7485"
			strokeOpacity="0.24"
			strokeWidth="0.25"
		/>
		<g filter="url(#doodle-marker-two-inner-shadow)">
			<path
				d="M23.3224 10.1464H14.7729C14.097 10.1464 13.4759 10.5181 13.1564 11.1137L2.30979 31.3393C2.07596 31.7753 1.9536 32.2624 1.9536 32.7572V34.9315C1.9536 35.4709 1.51627 35.9083 0.976801 35.9083C0.437329 35.9083 0 36.3456 0 36.8851V130.217C0 131.23 0.821209 132.051 1.83422 132.051H36.261C37.274 132.051 38.0952 131.23 38.0952 130.217V36.8851C38.0952 36.3456 37.6579 35.9083 37.1184 35.9083C36.579 35.9083 36.1416 35.4709 36.1416 34.9315V32.7572C36.1416 32.2624 36.0193 31.7753 35.7854 31.3393L24.9388 11.1137C24.6194 10.5181 23.9982 10.1464 23.3224 10.1464Z"
				fill="#F8F8F8"
				fillOpacity="0.99"
			/>
		</g>
		<path
			d="M14.7725 10.2714H23.3223C23.9521 10.2714 24.5314 10.6177 24.8291 11.1727L35.6748 31.3983C35.8988 31.816 36.0165 32.2827 36.0166 32.7567V34.9315C36.0166 35.5399 36.5098 36.0329 37.1182 36.0331C37.5885 36.0331 37.9705 36.4144 37.9707 36.8846V130.217C37.9707 131.161 37.2047 131.926 36.2607 131.926H1.83398C0.890118 131.926 0.125 131.161 0.125 130.217V36.8846C0.125228 36.4145 0.506375 36.0332 0.976562 36.0331C1.58505 36.0331 2.0781 35.54 2.07812 34.9315V32.7567C2.0782 32.2827 2.19591 31.816 2.41992 31.3983L13.2666 11.1727C13.5642 10.6178 14.1428 10.2715 14.7725 10.2714Z"
			stroke="#C0C0C0"
			strokeWidth="0.25"
		/>
		<g filter="url(#doodle-marker-two-neck-shadow)">
			<path d="M3.71436 35.813L3.71436 32.0035L34.1905 32.0035L34.1905 35.813L3.71436 35.813Z" fill="url(#doodle-marker-two-gradient)" fillOpacity="0.7" />
		</g>
		<g filter="url(#doodle-marker-two-highlight)">
			<rect x="28.5714" y="42.5273" width="5.71429" height="87.619" fill="white" fillOpacity="0.8" />
		</g>
		<path d="M37.9334 52L37.9334 56L0.333374 56L0.333374 52L37.9334 52Z" fill={color} />
		<defs>
			<filter
				id="doodle-marker-two-inner-shadow"
				x="0"
				y="9.22925"
				width="38.0952"
				height="122.822"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
				<feOffset dy="-0.917108" />
				<feGaussianBlur stdDeviation="1.83422" />
				<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
				<feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
			</filter>
			<filter
				id="doodle-marker-two-neck-shadow"
				x="2.79725"
				y="31.0864"
				width="32.3104"
				height="5.64372"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feGaussianBlur stdDeviation="0.458554" result="effect1_foregroundBlur" />
			</filter>
			<filter
				id="doodle-marker-two-highlight"
				x="25.7524"
				y="39.7083"
				width="11.3523"
				height="93.2571"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feGaussianBlur stdDeviation="1.40952" result="effect1_foregroundBlur" />
			</filter>
			<linearGradient id="doodle-marker-two-gradient" x1="18.9525" y1="32.0035" x2="18.9525" y2="35.813" gradientUnits="userSpaceOnUse">
				<stop stopColor="#E0E0E0" stopOpacity="0" />
				<stop offset="1" stopColor="#EBEBEB" />
			</linearGradient>
		</defs>
	</svg>
);

const MarkerThreeIcon: FC<MarkerIconProps> = ({ color }) => (
	<svg width="42" height="133" viewBox="0 0 42 133" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false">
		<path
			d="M13.3333 16.7533L13.3333 17.1429L28.5713 17.1429L28.5713 16.7533C28.5713 7.79223 25.1609 2.66627e-05 20.9523 2.68467e-05C16.7437 2.70306e-05 13.3333 7.79223 13.3333 16.7533Z"
			fill={color}
		/>
		<path
			d="M13.4583 16.7532C13.4583 12.2869 14.3088 8.1168 15.679 5.06769C16.3641 3.54296 17.1762 2.30352 18.0725 1.44757C18.9683 0.59219 19.9415 0.125305 20.9524 0.125305C21.9633 0.125333 22.9365 0.592157 23.8323 1.44757C24.7286 2.30352 25.5407 3.54296 26.2258 5.06769C27.5959 8.1168 28.4465 12.2869 28.4465 16.7532L28.4465 17.0179L13.4583 17.0179L13.4583 16.7532Z"
			stroke="#6B7485"
			strokeOpacity="0.24"
			strokeWidth="0.25"
		/>
		<g filter="url(#doodle-marker-three-inner-shadow)">
			<path
				d="M28.3001 15.2381H13.6047C12.5917 15.2381 11.7705 16.0593 11.7705 17.0723V25.3995C11.7705 25.5998 11.685 25.7906 11.5356 25.924L11.1739 26.247C7.70994 29.3398 4.6495 32.8568 2.06486 36.7149C1.99233 36.8231 1.9536 36.9505 1.9536 37.0809V38.1184C1.9536 38.6579 1.51627 39.0952 0.976801 39.0952C0.437329 39.0952 0 39.5326 0 40.072V129.594C0 130.607 0.821208 131.429 1.83422 131.429H40.0705C41.0836 131.429 41.9048 130.607 41.9048 129.594V40.072C41.9048 39.5326 41.4674 39.0952 40.928 39.0952C40.3885 39.0952 39.9512 38.6579 39.9512 38.1184V37.0809C39.9512 36.9505 39.9124 36.8231 39.8399 36.7149C37.2553 32.8568 34.1948 29.3398 30.7309 26.247L30.3691 25.924C30.2197 25.7906 30.1343 25.5998 30.1343 25.3995V17.0723C30.1343 16.0593 29.3131 15.2381 28.3001 15.2381Z"
				fill="#F8F8F8"
				fillOpacity="0.99"
			/>
		</g>
		<path
			d="M13.6045 15.3631H28.2998C29.2437 15.3631 30.0096 16.1282 30.0098 17.0721V25.3992C30.0098 25.6351 30.1102 25.8603 30.2861 26.0174L30.6475 26.3406C34.1035 29.4264 37.1576 32.9348 39.7363 36.784C39.7951 36.8717 39.8262 36.9753 39.8262 37.0809V38.118C39.8262 38.7264 40.3193 39.2204 40.9277 39.2205C41.3982 39.2205 41.7793 39.6016 41.7793 40.0721V129.595C41.7792 130.538 41.0142 131.304 40.0703 131.304H1.83398C0.890179 131.303 0.125099 130.538 0.125 129.595V40.0721C0.125 39.6017 0.506235 39.2206 0.976562 39.2205C1.58507 39.2205 2.07812 38.7265 2.07812 38.118V37.0809C2.07812 36.9753 2.1102 36.8717 2.16895 36.784C4.74758 32.935 7.80101 29.4263 11.2568 26.3406L11.6191 26.0174C11.7951 25.8603 11.8955 25.6351 11.8955 25.3992V17.0721C11.8956 16.1283 12.6607 15.3632 13.6045 15.3631Z"
			stroke="#C0C0C0"
			strokeWidth="0.25"
		/>
		<g filter="url(#doodle-marker-three-neck-shadow)">
			<path d="M4.09521 39.1905L4.09521 35.381L38.3809 35.381L38.3809 39.1905L4.09521 39.1905Z" fill="url(#doodle-marker-three-gradient)" fillOpacity="0.7" />
		</g>
		<g filter="url(#doodle-marker-three-highlight)">
			<rect x="32.3809" y="41.9048" width="5.71429" height="87.619" fill="white" fillOpacity="0.8" />
		</g>
		<path d="M41.238 48L41.238 56L0.238037 56L0.238037 48L41.238 48Z" fill={color} />
		<defs>
			<filter
				id="doodle-marker-three-inner-shadow"
				x="0"
				y="14.321"
				width="41.9048"
				height="117.108"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
				<feOffset dy="-0.917108" />
				<feGaussianBlur stdDeviation="1.83422" />
				<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
				<feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
			</filter>
			<filter
				id="doodle-marker-three-neck-shadow"
				x="3.17811"
				y="34.4639"
				width="36.12"
				height="5.64372"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feGaussianBlur stdDeviation="0.458554" result="effect1_foregroundBlur" />
			</filter>
			<filter
				id="doodle-marker-three-highlight"
				x="29.5618"
				y="39.0857"
				width="11.3523"
				height="93.2571"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feGaussianBlur stdDeviation="1.40952" result="effect1_foregroundBlur" />
			</filter>
			<linearGradient id="doodle-marker-three-gradient" x1="21.2381" y1="35.381" x2="21.2381" y2="39.1905" gradientUnits="userSpaceOnUse">
				<stop stopColor="#E0E0E0" stopOpacity="0" />
				<stop offset="1" stopColor="#EBEBEB" />
			</linearGradient>
		</defs>
	</svg>
);

const MarkerFourIcon: FC<MarkerIconProps> = ({ color }) => (
	<svg width="48" height="135" viewBox="0 0 48 135" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false">
		<path
			d="M32.5594 21.1006L32.5594 1.50164C32.5594 0.421996 31.4532 -0.304077 30.4627 0.125471L15.7183 6.51951C15.022 6.82148 14.5714 7.50803 14.5714 8.26702L14.5714 20.1037C14.5714 29.4837 23.0943 24.0913 28.0624 24.0913C33.0305 24.0913 32.5594 30.4806 32.5594 21.1006Z"
			fill={color}
		/>
		<path
			d="M32.4308 25.5195C32.4225 25.6975 32.4101 25.8316 32.3937 25.9297C32.3796 26.0135 32.3626 26.0595 32.3507 26.083C32.3321 26.074 32.3008 26.0562 32.255 26.0176C31.7753 25.6126 30.6051 23.9659 28.0626 23.9658C26.8031 23.9658 25.3235 24.3079 23.8292 24.666C22.3277 25.0259 20.8081 25.4033 19.4454 25.4902C18.0828 25.5771 16.9048 25.3715 16.0656 24.5928C15.226 23.8137 14.6964 22.4336 14.6964 20.1035L14.6964 8.2666C14.6966 7.55765 15.1173 6.91593 15.7677 6.63379L30.5128 0.240234C31.4207 -0.153209 32.4347 0.512402 32.4347 1.50195L32.4347 21.1006C32.4347 23.451 32.4641 24.8033 32.4308 25.5195Z"
			stroke="#6B7485"
			strokeOpacity="0.24"
			strokeWidth="0.25"
		/>
		<g filter="url(#doodle-marker-four-inner-shadow)">
			<path
				d="M34.4598 17.0733H13.1592C12.3922 17.0733 11.7705 17.6951 11.7705 18.4621C11.7705 24.3191 9.63756 29.9757 5.77044 34.3745L2.35392 38.2608C2.09591 38.5543 1.9536 38.9317 1.9536 39.3225V39.9536C1.9536 40.4931 1.51627 40.9304 0.976801 40.9304C0.437329 40.9304 0 41.3678 0 41.9072V131.43C0 132.443 0.82121 133.264 1.83422 133.264H45.7848C46.7978 133.264 47.619 132.443 47.619 131.43V41.9072C47.619 41.3678 47.1817 40.9304 46.6422 40.9304C46.1028 40.9304 45.6654 40.4931 45.6654 39.9536V39.3225C45.6654 38.9317 45.5231 38.5543 45.2651 38.2608L41.8486 34.3745C37.9815 29.9757 35.8486 24.3191 35.8486 18.4621C35.8486 17.6951 35.2268 17.0733 34.4598 17.0733Z"
				fill="#F8F8F8"
				fillOpacity="0.99"
			/>
		</g>
		<path
			d="M13.1592 17.1983H34.46C35.1578 17.1984 35.7236 17.7641 35.7236 18.462C35.7236 24.3494 37.8677 30.0354 41.7549 34.4571L45.1709 38.3428C45.4088 38.6135 45.54 38.962 45.54 39.3223V39.9532C45.54 40.5617 46.0341 41.0557 46.6426 41.0557C47.1129 41.0559 47.4941 41.437 47.4941 41.9073V131.43C47.494 132.374 46.7289 133.139 45.7852 133.139H1.83398C0.89018 133.139 0.125099 132.374 0.125 131.43V41.9073C0.125 41.4369 0.506235 41.0559 0.976562 41.0557C1.58507 41.0557 2.07812 40.5617 2.07812 39.9532V39.3223C2.07816 38.962 2.21032 38.6135 2.44824 38.3428L5.86426 34.4571C9.75143 30.0354 11.8955 24.3494 11.8955 18.462C11.8956 17.7641 12.4613 17.1983 13.1592 17.1983Z"
			stroke="#C0C0C0"
			strokeWidth="0.25"
		/>
		<g filter="url(#doodle-marker-four-neck-shadow)">
			<rect
				x="3.80957"
				y="41.0257"
				width="3.80952"
				height="40"
				transform="rotate(-90 3.80957 41.0257)"
				fill="url(#doodle-marker-four-gradient)"
				fillOpacity="0.7"
			/>
		</g>
		<g filter="url(#doodle-marker-four-highlight)">
			<rect x="36.1904" y="43.74" width="7.61905" height="87.619" fill="white" fillOpacity="0.8" />
		</g>
		<path d="M47.3334 46L47.3334 56L0.333374 56L0.333374 46L47.3334 46Z" fill={color} />
		<defs>
			<filter
				id="doodle-marker-four-inner-shadow"
				x="0"
				y="16.1562"
				width="47.619"
				height="117.108"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
				<feOffset dy="-0.917108" />
				<feGaussianBlur stdDeviation="1.83422" />
				<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
				<feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
			</filter>
			<filter
				id="doodle-marker-four-neck-shadow"
				x="2.89246"
				y="36.2991"
				width="41.8342"
				height="5.64372"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feGaussianBlur stdDeviation="0.458554" result="effect1_foregroundBlur" />
			</filter>
			<filter
				id="doodle-marker-four-highlight"
				x="33.3714"
				y="40.9209"
				width="13.2571"
				height="93.2571"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feGaussianBlur stdDeviation="1.40952" result="effect1_foregroundBlur" />
			</filter>
			<linearGradient id="doodle-marker-four-gradient" x1="7.61909" y1="61.0257" x2="3.80957" y2="61.0257" gradientUnits="userSpaceOnUse">
				<stop stopColor="#E0E0E0" stopOpacity="0" />
				<stop offset="1" stopColor="#EBEBEB" />
			</linearGradient>
		</defs>
	</svg>
);

export const EraserIcon: FC = () => (
	<svg width="50" height="134" viewBox="0 0 50 134" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false">
		<g filter="url(#doodle-eraser-inner-shadow)">
			<rect x="0.917236" width="47.6896" height="74.2857" rx="1.83422" fill="#FCF3EF" />
		</g>
		<g filter="url(#doodle-eraser-top-shadow)">
			<rect
				x="3.80957"
				y="15.2381"
				width="3.80952"
				height="41.9048"
				transform="rotate(-90 3.80957 15.2381)"
				fill="url(#doodle-eraser-top-gradient)"
				fillOpacity="0.7"
			/>
		</g>
		<g filter="url(#doodle-eraser-highlight)">
			<rect x="45.8555" y="0.917114" width="1.83422" height="19.2593" fill="white" />
		</g>
		<rect y="15.2381" width="49.5238" height="118.095" rx="0.458554" fill="url(#doodle-eraser-body-gradient)" />
		<g filter="url(#doodle-eraser-edge)">
			<rect x="47.6897" y="15.2381" width="0.917108" height="115.132" fill="#91A5ED" />
		</g>
		<defs>
			<filter
				id="doodle-eraser-inner-shadow"
				x="0.917236"
				y="-0.917108"
				width="47.6896"
				height="75.2028"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
				<feOffset dy="-0.917108" />
				<feGaussianBlur stdDeviation="1.83422" />
				<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
				<feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
			</filter>
			<filter
				id="doodle-eraser-top-shadow"
				x="2.89246"
				y="10.5115"
				width="43.739"
				height="5.64372"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feGaussianBlur stdDeviation="0.458554" result="effect1_foregroundBlur" />
			</filter>
			<filter id="doodle-eraser-highlight" x="44.9384" y="0" width="3.66844" height="21.0935" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feGaussianBlur stdDeviation="0.458554" result="effect1_foregroundBlur" />
			</filter>
			<filter id="doodle-eraser-edge" x="46.7726" y="14.321" width="2.75133" height="116.966" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feGaussianBlur stdDeviation="0.458554" result="effect1_foregroundBlur" />
			</filter>
			<linearGradient id="doodle-eraser-top-gradient" x1="7.61909" y1="36.1905" x2="3.80957" y2="36.1905" gradientUnits="userSpaceOnUse">
				<stop stopColor="#E0E0E0" stopOpacity="0" />
				<stop offset="1" stopColor="#EBEBEB" />
			</linearGradient>
			<linearGradient id="doodle-eraser-body-gradient" x1="0" y1="74.2857" x2="49.5238" y2="74.2857" gradientUnits="userSpaceOnUse">
				<stop stopColor="#15458C" />
				<stop offset="0.0528846" stopColor="#265DAC" />
				<stop offset="1" stopColor="#265DAC" />
			</linearGradient>
		</defs>
	</svg>
);

export const MARKER_ICONS = [MarkerOneIcon, MarkerTwoIcon, MarkerThreeIcon, MarkerFourIcon] as const;
